module.exports = __webpack_public_path__ + "img/1474710963.73d3a4bd.jpg";